/* Custom JS */
const $body = document.querySelector('body'),
    $productSection = document.getElementsByClassName('js-product-section'),
    isProductPage = document.body.classList.contains('product');
    isPHListing = document.querySelector('.ph-listing');

/*const tabs = () => {
    // tabs
    const tabLinks = document.querySelectorAll('.tablinks'),
        tabContent = document.querySelectorAll('.tabcontent');

    const openTabs = (el) => {
       const btnTarget = el.currentTarget,
        tabTarget = btnTarget.dataset.tab_target;

       tabContent.forEach((el) => {
          el.classList.remove('active');
       });

       tabLinks.forEach((el) => {
          el.classList.remove('active');
       });

       document.querySelector(`#${tabTarget}`).classList.add('active');
       
       btnTarget.classList.add('active');
    }

    tabLinks.forEach((el) => {
       el.addEventListener('click', openTabs);
    });
};
*/
const toggleSlide = (selector, hideSelector = 'hidden', $trigger = '', triggerActiveClass = '') => {

    const div = document.querySelector(`${selector}`)

    if (div.classList.contains(hideSelector)) {
        if (triggerActiveClass.length > 0) {
            $trigger.classList.add(triggerActiveClass);
        }
        div.classList.remove(hideSelector)
    } else {
        if (triggerActiveClass.length > 0) {
            $trigger.classList.remove(triggerActiveClass);
        }
        div.classList.add(hideSelector)
    }
}

const accordion = (selector = {}) => {
    const accordionLi = document.querySelectorAll(selector);

    accordionLi.forEach((item, index) => {
        if (index % 2 === 0) {
            item.addEventListener('click', (e) => {
                const nextItem = accordionLi[index + 1];

                if (nextItem) {
                    if (nextItem.style.maxHeight) {
                        item.classList.remove('accordion-active');
                        nextItem.style.maxHeight = null;
                    } else {
                        item.classList.add('accordion-active');
                        nextItem.style.maxHeight = `${nextItem.scrollHeight}px`;
                    }
                }
            });
        }
    });
};

const setUniformHeight = (selector) => {
    const elements = document.querySelectorAll(selector);

    let maxHeight = 0;

    elements.forEach(element => {
        const height = element.offsetHeight;
        if (height > maxHeight) {
            maxHeight = height;
        }
    });

    elements.forEach(element => {
        element.style.height = `${maxHeight}px`;
    });
};

const colourSwitcher = () => {
    const appendHere = document.getElementById('append-here');
    let colorCounts = {},
        activeFilter = null;

    // Collect colors and their counts
    const colorSortDivs = document.querySelectorAll('.js-ph-color-sort');
    colorSortDivs.forEach((div) => {
        const colors = div.getAttribute('data-color').split(',');

        colors.forEach((color) => {
            if (color) {
                color = color.trim();
                if (colorCounts[color]) {
                    colorCounts[color]++;
                } else {
                    colorCounts[color] = 1;
                }
            }
        });
    });

    // Create the filter list
    const ul = document.createElement('ul');
    ul.className = 'ph-colours-filter-list';

    for (let color in colorCounts) {
        if (colorCounts.hasOwnProperty(color)) {
            let li = document.createElement('li'),
                a = document.createElement('a');

            a.className = 'js-ph-color-sort-trigger';
            a.setAttribute('data-color', color);
            a.href = 'javascript:void(0);';
            a.textContent = ` (${colorCounts[color]})`;
            li.appendChild(a);
            ul.appendChild(li);
        }
    }

    // Add the clear option
    const clearLi = document.createElement('li'),
        clearA = document.createElement('a');

    clearA.href = 'javascript:void(0);';
    clearA.className = 'no-bg clear-button';
    clearA.textContent = 'clear';

    clearA.addEventListener('click', () => {
        clearFilters();
    });

    clearLi.appendChild(clearA);
    ul.appendChild(clearLi);

    appendHere.appendChild(ul);

    // Attach event listener to all generated anchor tags
    const colorLinks = document.querySelectorAll('.js-ph-color-sort-trigger');
    colorLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            const selectedColor = e.target.getAttribute('data-color');

            toggleFilter(selectedColor);
        });
    });

    const updateCounts = () => {
        let visibleCounts = {};

        colorSortDivs.forEach((div) => {
            if (!div.closest('li').classList.contains('filter-hide')) {
                const colors = div.getAttribute('data-color').split(',');

                colors.forEach((color) => {
                    if (color) {
                        color = color.trim();
                        if (visibleCounts[color]) {
                            visibleCounts[color]++;
                        } else {
                            visibleCounts[color] = 1;
                        }
                    }
                });
            }
        });

        colorLinks.forEach((link) => {
            const color = link.getAttribute('data-color');

            if (visibleCounts[color]) {
                link.textContent = ` (${visibleCounts[color]})`;
            } else {
                link.textContent = ` (0)`;
            }
        });
    };

    const toggleFilter = (color) => {
        if (activeFilter === color) {
            clearFilters();
        } else {
            filterColors(color);
            activeFilter = color;
        }
        updateCounts();
    };

    const filterColors = (color) => {
        colorSortDivs.forEach((div) => {
            const parentLi = div.closest('li');

            if (div.getAttribute('data-color').split(',').indexOf(color) === -1) {
                parentLi.classList.add('filter-hide');
            } else {
                parentLi.classList.remove('filter-hide');
            }
        });
    };

    const clearFilters = () => {
        colorSortDivs.forEach((div) => {
            const parentLi = div.closest('li');
            parentLi.classList.remove('filter-hide');
        });

        activeFilter = null;
        updateCounts();
    };

    updateCounts();
};

const modalGallery = () => {
    const thumbnails = document.querySelectorAll('.js-product-images-modal-thumbs'),
        activeImage = document.querySelectorAll('.product-media-modal')[0].dataset,
        allProductImagesList = document.querySelectorAll('.product-images-content');

    thumbnails[0].addEventListener('click', (e) => {
        e.preventDefault();

        if (e.target === thumbnails[0]) {
            return false;
        }
        
        const closestLi = e.target.closest('li'),
            liIndex = [...thumbnails[0].children].indexOf(closestLi);

        document.querySelectorAll('.product-images-modal-thumbs li.active')[0].classList.remove('active');
        closestLi.classList.add('active');
        document.querySelectorAll('.product-images-modal-images li.active')[0].classList.remove('active');
        document.querySelectorAll('.product-images-modal-images li')[liIndex].classList.add('active');        
    });
};

const productPageStuff = () => {
    const productBackgroundColour = $productSection[0].getAttribute('data-bg_colour');
    
    $body.style.background = productBackgroundColour;
    setTimeout(() => {
        $body.classList.add('fadeIn');
    }, 250);
    tabs();
    modalGallery();
    accordion('#Faqs ul li');
};

document.addEventListener('DOMContentLoaded', () => {
    if (isProductPage) {
        productPageStuff();
    }

    if (isPHListing) {
        setUniformHeight('.card__heading');
        colourSwitcher();



        const $selector = document.querySelectorAll('.collection__all-listing-item'),
            $colourToggler = document.querySelector('.js-toggle-colours');

        $colourToggler.addEventListener('click', (e) => {
            toggleSlide('#append-here', 'hide-it', e.currentTarget,'active');
        });

        $selector.forEach((sel) => {
            const $heading = sel.querySelector('h1');

            new simpleParallax($heading, {
                delay: .6,
                transition: 'cubic-bezier(0,0,0,1)',
                scale: 1.2
            });

        });
        
    }
});